import React, { ChangeEvent, FC, useState } from 'react'
import { InputGroup, Box, Button, Flex, Input, Text } from '@chakra-ui/react'
import theme from '../../styles'
import { Icon } from '../icon'
import { useTranslation } from 'react-i18next'
import { selectScenario, useSelector } from '../../state'
import { ScenarioType } from '../../state/interfaces'

export interface InputCurrencyProps {
  placeholder?: string
  onChange?: (values: string[]) => void
  name: string
}

export const InputCurrency: FC<InputCurrencyProps> = ({ onChange, name }) => {
  const { t } = useTranslation()
  // const prefix = '$ '
  const [value, setValue] = useState<string>('')
  const [errorMsg, setErrorMsg] = useState<string>('')
  const scenario = useSelector(selectScenario)

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault()
    const original = event.target.value
    const transformed = original.replace(/,/g, '.')
    let sanitized = transformed.replace(/[^0-9.]/g, '')
    const parts = sanitized.split('.')
    const intPart = parts.shift() || ''
    sanitized = intPart + (parts.length ? '.' + parts.join('') : '')

    // If sanitized differs from transformed, there are disallowed characters
    const hasDisallowed = sanitized !== transformed
    if (hasDisallowed) {
      setErrorMsg(t('accepted-characters-only-numeric'))
    }

    if (!isNaN(Number(sanitized))) {
      if (Number(sanitized) > 500) {
        setValue('500')
        setErrorMsg(t('maximum-500'))
      } else {
        setValue(sanitized)
        if (!hasDisallowed) setErrorMsg('')
      }
    }
  }

  const handleOnBlur = () => {
    if (value && Number(value) > 0) {
      setValue(Number(value).toFixed(2))
      if (Number(value) <= 500) setErrorMsg('')
    } else {
      setValue('')
      setErrorMsg('')
    }
  }

  return (
    <Box spacing={3} marginY={8} width={'full'} maxWidth={350}>
      <InputGroup
        display="grid"
        outline="none"
        borderRadius="md"
        variant="none"
        fontSize={22}
        paddingLeft={4}
        layerStyle={theme.LayerStyles.INPUT}
      >
        <Input
          name={name}
          id="currencyInput"
          value={value}
          placeholder="$ 0.00"
          onChange={handleChange}
          onBlur={handleOnBlur}
          onClick={(e) => {
            e.stopPropagation()
            e.currentTarget.focus()
          }}
          onKeyPress={(ev) => {
            if (ev.key === 'Enter' && value) {
              ev.preventDefault()
              onChange && onChange([value.toString()])
            }
          }}
          autoFocus
          autoComplete="off"
          fontSize={22}
          variant="unstyled"
        />
        {value && (
          <Button
            role={'button'}
            position="absolute"
            borderRadius="md"
            layerStyle={theme.LayerStyles.BTN_INPUT_PILL}
            onClick={() => {
              onChange && onChange([value.toString()])
            }}
          >
            <Icon icon="arrow-right" color="white" />
          </Button>
        )}
      </InputGroup>
      {scenario && (scenario.type === ScenarioType.INTERNET_ALERT || scenario.type === ScenarioType.MOBILE_ALERT) && (
        <Flex justifyContent="flex-end">
          <Button
            borderRadius="md"
            onClick={() => {
              onChange && onChange([''])
            }}
            marginTop="0.5em"
            textColor="darkgray"
            fontSize={20}
          >
            {t('common_skip')}
          </Button>
        </Flex>
      )}
      {errorMsg && (
        <Text color="red" fontSize={14} marginTop={2} role="alert">
          {errorMsg}
        </Text>
      )}
    </Box>
  )
}
